export type VanDerValkNormalizedGridCell = {
  cellKey: string
  ncol: number
  nrow: number
}

/** Same ncol/nrow origin as ``frames`` matrices (min col/row → 0,0). */
export function normalizeVanDerValkGridCells(cellsActive: string[]): VanDerValkNormalizedGridCell[] | null {
  if (!cellsActive.length) {
    return null
  }
  const parsed: { cellKey: string; col: number; row: number }[] = []
  for (const cellKey of cellsActive) {
    if (typeof cellKey !== 'string' || !cellKey.includes(',')) {
      continue
    }
    const [xStr, yStr] = cellKey.split(',')
    const x = Number(xStr)
    const y = Number(yStr)
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      continue
    }
    parsed.push({ cellKey, col: -x, row: y })
  }
  if (!parsed.length) {
    return null
  }
  const minCol = Math.min(...parsed.map((p) => p.col))
  const minRow = Math.min(...parsed.map((p) => p.row))
  return parsed.map((p) => ({
    cellKey: p.cellKey,
    ncol: p.col - minCol,
    nrow: p.row - minRow,
  }))
}
